import { getMarketOverviewBreadcrumbsRoute } from '@/finsight/ui/common/helpers';
import URL from '@/finsight/Router/urlConstants';

const getStratsBreadcrumbs = (stratsId: number) => [
  getMarketOverviewBreadcrumbsRoute(),
  {
    title: 'Loan-Level Data (ABS-EE)',
    url: URL.PRODUCT_US_ABS_EE,
  },
  {
    title: `StratMaker (${ stratsId })`,
    isActive: true,
  },
];

export default getStratsBreadcrumbs;
